module.exports = __webpack_public_path__ + "img/financira-eu.c88ba9fc.jpg";